const actions = {
    GET_USERS_REQUEST: 'GET_USERS_REQUEST',
    CREATE_USER_REQUEST: 'CREATE_USER_REQUEST',
    EDIT_USER_REQUEST: 'EDIT_USER_REQUEST',
    DELETE_USER_REQUEST: 'DELETE_USER_REQUEST',

    GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
    GET_USERS_SUCCESS_QUERY: 'GET_USERS_SUCCESS_QUERY',
    CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
    EDIT_USER_SUCCESS: 'EDIT_USER_SUCCESS',
    DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',

    SET_CURRENT_USER: 'SET_CURRENT_USER',
    CLEAR_CURRENT_USER: 'CLEAR_CURRENT_USER',

    FETCH_NOVEDADES_REQUEST: 'FETCH_NOVEDADES_REQUEST',
    FETCH_NOVEDADES_SUCCESS: 'FETCH_NOVEDADES_SUCCESS',
    REGISTRAR_NOVEDAD_REQUEST: 'REGISTRAR_NOVEDAD_REQUEST',
    REGISTRAR_NOVEDAD_SUCCESS: 'REGISTRAR_NOVEDAD_SUCCESS',

    initDataUsers: (query) => ({ query, type: actions.GET_USERS_REQUEST }),
    createUser: data => ({
        type: actions.CREATE_USER_REQUEST,
        payload: data
    }),
    editUser: data => ({
        type: actions.EDIT_USER_REQUEST,
        payload: data
    }),
    deleteUser: id => ({
        type: actions.DELETE_USER_REQUEST,
        payload: id
    }),
    setCurrentUser: data => ({
        type: actions.SET_CURRENT_USER,
        payload: data
    }),
    clearCurrentUser: () => ({
        type: actions.CLEAR_CURRENT_USER,
    }),
    fetchNovedades: ({ empleadoId, mes, anio }) => ({
        type: actions.FETCH_NOVEDADES_REQUEST,
        payload: { empleadoId, mes, anio },
    }),
    registrarNovedad: (data) => ({
        type: actions.REGISTRAR_NOVEDAD_REQUEST,
        payload: data,
    }),

};
export default actions;